import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {API_CALL_STATUS} from '../../metadata/enums'
import {FETCH_TOTAL_WORK_ORDERS_COUNT} from "../actionTypes";
import Config from "../../config";
import axios from "axios";
import {getSettingsData, updateSettingsData} from "./settingsSlice";

const initialState = {
	token: null,
	status: API_CALL_STATUS.IDLE,
	error: null,
	access_allowed: true,
	new_work_orders_pages: 20,
	engaging_work_orders_pages: 1,
	ignored_work_orders_pages: 1,
}

export const getTotalWorkOrdersCount = createAsyncThunk(FETCH_TOTAL_WORK_ORDERS_COUNT, async (payload) => {
	const config = {
		method: 'get',
		url: `${Config.BACKEND_URL}work-orders-count`,
		headers: {Authorization: payload.token},
	}
	let res = await axios(config)
	return res.data
})

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		addToken(state, action) {
			return Object.assign({}, state, {token: action.payload})
		},
		changeUserAccess(state, action) {
			return Object.assign({}, state, {access_allowed: action.payload})
		}
	},
	extraReducers(builder) {
		builder
		.addCase(getTotalWorkOrdersCount.pending, (state, action) => {
			state.status = API_CALL_STATUS.LOADING
		})
		.addCase(getTotalWorkOrdersCount.fulfilled, (state, action) => {
			state.status = API_CALL_STATUS.SUCCEEDED
			let {newOrders, engagingOrders, ignoredOrders} = action.payload
			state.new_work_orders_pages = Math.ceil(newOrders / Config.WORK_ORDERS_PAGE_SIZE)
			state.engaging_work_orders_pages = Math.ceil(engagingOrders / Config.WORK_ORDERS_PAGE_SIZE)
			state.ignored_work_orders_pages = Math.ceil(ignoredOrders / Config.WORK_ORDERS_PAGE_SIZE)
		})
		.addCase(getTotalWorkOrdersCount.rejected, (state, action) => {
			state.status = API_CALL_STATUS.FAILED
			state.error = action.error.message
		})
	}
})


export const { addToken, changeUserAccess } = authSlice.actions

export default authSlice.reducer
